// Could be made into a plugin with an #install method?
export default function storeDonation (vueInstance, lokalStorage) {
  const tmp = { ...vueInstance.donationStore.donationParams }
  const parsedDonation = JSON.stringify(tmp)
  lokalStorage.setItem('donation', parsedDonation)
  lokalStorage.location = vueInstance.$l10n.currentLocation.key
}
